import { Box } from '@mui/material';

import IndicatorLeadStage, {
  type IndicatorStatus,
} from '@modules/_shared/components/IndicatorLeadStage';

const isIndicatorStatus = (
  value: string | null | undefined,
): value is IndicatorStatus =>
  value === 'won' || value === 'lost' || value === 'active';

interface BuyerLeadColumnTitleProps {
  label?: string | null;
  status?: string | null;
  count: number;
}

export const BuyerLeadColumnTitle: React.FC<BuyerLeadColumnTitleProps> = ({
  label,
  status,
  count,
}) => (
  <Box sx={{ flexGrow: 1, minWidth: 0, '& > div': { maxWidth: '100%' } }}>
    {label == null ? (
      '-'
    ) : (
      <IndicatorLeadStage
        status={isIndicatorStatus(status) ? status : undefined}
      >
        <Box
          component="span"
          title={label}
          sx={{
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >{`${label} (${count})`}</Box>
      </IndicatorLeadStage>
    )}
  </Box>
);
